module.exports = __webpack_public_path__ + "static/media/manager-r-4.5ad0fd8b.png";